import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

const STATUS = {
  en_attente: "En attente",
  contacte: "Contacté",
  livre: "Livré",
};

export default function AdminPreorders() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/preorders").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/admin/preorders/${id}/status?status=${status}`);
      toast.success("Statut mis à jour");
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const remove = async (id) => {
    if (!window.confirm("Supprimer cette précommande ?")) return;
    try {
      await api.delete(`/admin/preorders/${id}`);
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <h1 className="font-display text-3xl lg:text-4xl mb-2">Précommandes</h1>
      <p className="text-xs uppercase tracking-widest text-[#6B6B6B] mb-8">{list.length} demande(s)</p>

      <div className="border border-black/5 bg-white overflow-x-auto" data-testid="preorders-table">
        <table className="w-full text-sm min-w-[700px]">
          <thead className="border-b border-black/5 text-[10px] uppercase tracking-widest text-[#6B6B6B]">
            <tr>
              <th className="px-4 py-3 text-left">Produit</th>
              <th className="px-4 py-3 text-left">Client</th>
              <th className="px-4 py-3 text-left">Téléphone</th>
              <th className="px-4 py-3 text-left">Lieu</th>
              <th className="px-4 py-3 text-left">Date</th>
              <th className="px-4 py-3 text-left">Statut</th>
              <th className="px-4 py-3 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && (
              <tr><td colSpan="7" className="text-center py-12 text-[#6B6B6B]">Aucune précommande.</td></tr>
            )}
            {list.map((p) => (
              <tr key={p.id} className="border-b border-black/5">
                <td className="px-4 py-3 text-[#1A1A1A]">{p.product_name}</td>
                <td className="px-4 py-3">{p.customer_name}</td>
                <td className="px-4 py-3 text-[#6B6B6B]">{p.phone}</td>
                <td className="px-4 py-3 text-[#6B6B6B]">{p.location}</td>
                <td className="px-4 py-3 text-xs text-[#6B6B6B]">{new Date(p.created_at).toLocaleDateString("fr-FR")}</td>
                <td className="px-4 py-3">
                  <select
                    value={p.status}
                    onChange={(e) => setStatus(p.id, e.target.value)}
                    className="input-gold !py-1 !px-2 text-xs"
                    data-testid={`preorder-status-${p.id}`}
                  >
                    {Object.entries(STATUS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3">
                  <button onClick={() => remove(p.id)} className="p-2 hover:text-red-400" data-testid={`delete-preorder-${p.id}`}>
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
